import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex gap-4 mt-4" }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex col-span-full gap-4" }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-darkGray-1 mb-1 flex items-center gap-2 col-span-full"
}
const _hoisted_10 = { class: "text-darkGray-1 mb-1 flex items-center gap-2" }
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col col-span-full"
}
const _hoisted_12 = { class: "text-darkGray-1 mb-1 flex items-center gap-2" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 3,
  class: "flex flex-col col-span-full"
}
const _hoisted_17 = { class: "text-darkGray-1 mb-1 flex items-center gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_19 = { class: "flex col-span-full gap-4" }

import { ref, onMounted, watch } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputText from "@/features/shared/components/form/InputText.vue";
import SummerPeriodsEditor from "@/features/shared/components/form/editor/SummerPeriodsEditor.vue";
import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import { FormBuilder2 } from "@/models/FormBuilder2";
import { ToastNotification } from "@/models/ToastNotification";
import RegularButton from "../ui/RegularButton.vue";
import BaseInput from "./BaseInput.vue";
import { DynamicProperty } from "../../models/dtos";
import SsnAgeInPeriods from "./validators/SsnAgeInPeriods.vue";
import RadioGroupEditor from "./editor/RadioGroupEditor.vue";

interface SsnPeriod {
  key: string;
  periodStart: string;
  periodEnd: string;
  ageLow: number;
  ageHigh: number;
}

interface SsnAgeBeforeAndAfterPeriod {
  value: boolean;
  periods: SsnPeriod[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ElementEditor',
  props: {
    model: {},
    index: {}
  },
  emits: ["change", "remove", "isEdit", "customChange"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const store = useStore();
const form = ref(store.getters.form as FormBuilder2);

const props = __props;
// const old = JSON.parse(JSON.stringify(props.model));
const item = ref(props.model as dtos.DynamicProperty);
const isLoaded = ref(false);

const saveItem = (item: DynamicProperty) => {
  // form.value.setPeriodItem(item);
};
// function save() {
//   const x = {
//     value: old,
//     index: props.index,
//   };
//   emit("change", x);
// }

const back = () => {
  emit("isEdit", false);
};

function remove() {
  store.dispatch(
    "addNotification",
    new ToastNotification("success", "Fältet har tagits bort")
  );
  const form = store.getters.form as FormBuilder2;
  form.removeByProperty(item.value);
  emit("isEdit", false);
  // emit("remove", item.value);s
}

function removeOption(optionKey: DynamicProperty) {
  form.value.removeOptionFromGroup(item.value.data, optionKey, item.value.key);
}
function removePeriod2(item: DynamicProperty) {
  form.value.removePeriodFromGroup(item);
}
function addNewPeriod(key: string, item: DynamicProperty) {
  form.value.addPeriodToGroup(key, item);
}

function addNewRadio(key: string, item: DynamicProperty) {
  form.value.addRadioToGroup(key, item);
}
function changeRadioLabel(key: string, newLabel: string) {
  const form = store.getters.form as FormBuilder2;

  form.changeRadioButtonLabel(key, newLabel);
}

function removeRadio(item: DynamicProperty) {
  form.value.removeRadioFromGroup(item);
}

function addOption() {
  form.value.addOptionToGroup(item.value.data, item.value.key);
}

function onLabelChange(event: any) {
  item.value.data.label = event;
  item.value.label = event;
  item.value.placeholder = event;

  form.value.setCheckboxGroupLabel(item.value, event);
  emit("customChange", item.value);
}

const ssnOnlyAllowedYears = ref(false);

const ssnAgeBeforeAndAfterPeriod = ref<SsnAgeBeforeAndAfterPeriod>({
  value: false,
  periods: [],
}); 

const addPeriod = () => {
  ssnAgeBeforeAndAfterPeriod.value.periods.push({
    key: crypto.randomUUID(),
    periodStart: "",
    periodEnd: "",
    ageLow: 0,
    ageHigh: 0,
  });
};

const removePeriod = (index: number) => {
  ssnAgeBeforeAndAfterPeriod.value.periods.splice(index, 1);
  updateValidationWithPeriods();
};

const savePeriod = (period: SsnPeriod, index: number) => {
  ssnAgeBeforeAndAfterPeriod.value.periods[index] = period;
  updateValidationWithPeriods();
};
const initAllowedAgeInPeriod = () => {
  const validator = item.value.validators.find(
    (validator) => validator.name === "allowedAgeInPeriod"
  );
  if (validator) {
    item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    
    validator.data.forEach( ((element :any) => {
      ssnAgeBeforeAndAfterPeriod.value.periods.push({
      key: crypto.randomUUID(),
      periodStart: element.periodStart,
      periodEnd: element.periodEnd,
      ageLow: element.minAge,
      ageHigh: element.maxAge,
  });
    }));
  }
    if (ssnAgeBeforeAndAfterPeriod.value.periods.length > 0) ssnAgeBeforeAndAfterPeriod.value.value = true;
  
};
const updateValidationWithPeriods = () => {
  const validator = item.value.validators.find(
    (validator) => validator.name === "allowedAgeInPeriod"
  );
  if (validator) {
    item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    
    
  
    if (ssnAgeBeforeAndAfterPeriod.value.periods.length > 0) ssnAgeBeforeAndAfterPeriod.value.value = true;
    
  }

  if (ssnAgeBeforeAndAfterPeriod.value.periods.length === 0) {
    //return;
  }

  const newValidation = new dtos.PropertyValidator(
    "allowedAgeInPeriod",
    ssnAgeBeforeAndAfterPeriod.value.periods.map((period) => {
      return {
        periodStart: period.periodStart,
        periodEnd: period.periodEnd,
        minAge: period.ageLow,
        maxAge: period.ageHigh,
      };
    })
  );

  item.value.validators.push(newValidation);
};

const ssnAllowedYears = ref([]);

function addYear() {
  ssnAllowedYears.value.push("");
}

function removeYear(index: number) {
  ssnAllowedYears.value.splice(index, 1);
}

watch(
  () => ssnAllowedYears,
  (newValue, oldValue) => {
    const validator = item.value.validators.find(
      (validator) => validator.name === "allowedYears"
    );

    if (validator) {
      item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    }

    const minYear = new dtos.PropertyValidator(
      "allowedYears",
      ssnAllowedYears.value.join(",")
    );

    item.value.validators.push(minYear);
  },
  { deep: true }
);

watch(
  () => ssnOnlyAllowedYears.value,
  (newValue, oldValue) => {
    if (!newValue) {
      const validator = item.value.validators.find(
        (validator) => validator.name === "allowedYears"
      );

      if (validator) {
        item.value.validators.splice(
          item.value.validators.indexOf(validator),
          1
        );
      }
    }
  }
);

// file upload
const fileUploadIsRequired = ref(false);

onMounted(() => {
  const allowedYears = item.value.validators.find(
    (validator) => validator.name === "allowedYears"
  )?.data;

  if (allowedYears) {
    ssnOnlyAllowedYears.value = true;
    ssnAllowedYears.value = allowedYears.split(",");
  }

  const fileIsRequired = item.value.validators.find(
    (validator) => validator.name === "fileRequired"
  )?.data;

  if (fileIsRequired) {
    fileUploadIsRequired.value = true;
  }
initAllowedAgeInPeriod();
  isLoaded.value = true;
});

watch(
  () => fileUploadIsRequired.value,
  (newValue, oldValue) => {
    const validator = item.value.validators.find(
      (validator) => validator.name === "fileRequired"
    );

    if (validator) {
      item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    }

    const fileRequired = new dtos.PropertyValidator(
      "fileRequired",
      fileUploadIsRequired.value
    );

    item.value.validators.push(fileRequired);
  }
);

watch(
  () => ssnAgeBeforeAndAfterPeriod.value.value,
  (newValue) => {
    if (!newValue) {
      ssnAgeBeforeAndAfterPeriod.value.periods = [];
      updateValidationWithPeriods();
    }
  }
);

const onToggleRadioRequired = (value: boolean) => {
  store.dispatch("formbuilder/toggleIsRequired", {
    key: item.value.key,
    value: value,
  });
};

return (_ctx: any,_cache: any) => {
  return (item.value.key === 'summerperiodsform')
    ? (_openBlock(), _createBlock(SummerPeriodsEditor, {
        key: 0,
        model: props.model,
        metadata: form.value.metadata,
        onAdd: addNewPeriod,
        onRemove: removePeriod2,
        onLabelChange: onLabelChange,
        onBack: back,
        onRemoveField: remove,
        onSaveItem: saveItem
      }, null, 8, ["model", "metadata"]))
    : (item.value.type === 'group')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-4" }, "Dina förändringar sparas automatiskt.", -1)),
          _createElementVNode("form", {
            class: "grid grid-cols-4 gap-4",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(InputText, {
              keyId: "0",
              placeholder: item.value.label,
              label: "Rubrik för checkboxgrupp",
              model: item.value.label,
              type: "text",
              onChange: onLabelChange,
              class: "col-span-full"
            }, null, 8, ["placeholder", "model"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.data.keys, (prop, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex col-span-full gap-4 items-center",
                key: i
              }, [
                _createVNode(BaseInput, {
                  modelValue: prop.label,
                  "onUpdate:modelValue": ($event: any) => ((prop.label) = $event),
                  label: `checkbox ${i + 1}`,
                  placeholder: "Ange texten för checkboxen"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                _createElementVNode("i", {
                  onClick: ($event: any) => (removeOption(prop)),
                  title: "Ta bort",
                  class: "fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
                }, null, 8, _hoisted_2)
              ]))
            }), 128))
          ], 32),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(RegularButton, {
              onClick: addOption,
              "style-type": "primary",
              text: "Lägg till val"
            }),
            _createVNode(RegularButton, {
              onClick: remove,
              "style-type": "cancel",
              text: "Ta bort grupp"
            }),
            _createVNode(RegularButton, {
              onClick: back,
              "style-type": "success",
              text: "Spara"
            }),
            _createVNode(RegularButton, {
              onClick: back,
              text: "Tillbaka"
            })
          ])
        ]))
      : (item.value.type === 'radioGroup')
        ? (_openBlock(), _createBlock(RadioGroupEditor, {
            key: 2,
            model: props.model,
            metadata: form.value.metadata,
            onAdd: addNewRadio,
            onRemove: removeRadio,
            onLabelChange: onLabelChange,
            onBack: back,
            onRemoveField: remove,
            onChangeRadioLabel: changeRadioLabel,
            onToggleRadioRequired: onToggleRadioRequired
          }, null, 8, ["model", "metadata"]))
        : (item.value.type === 'textWithHelpLink')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mb-4" }, "Dina förändringar sparas automatiskt.", -1)),
              _createElementVNode("form", {
                action: "",
                class: "grid grid-cols-2 text-sm font-regular gap-4",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1" }, " Label ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                    placeholder: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.label) = $event))
                  }, null, 512), [
                    [_vModelText, item.value.label]
                  ])
                ]),
                (item.value.key !== 'form_file')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1" }, " Länk ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.placeholder) = $event))
                      }, null, 512), [
                        [_vModelText, item.value.placeholder]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(RegularButton, {
                    onClick: remove,
                    "style-type": "cancel",
                    text: "Ta bort fält"
                  }),
                  _createVNode(RegularButton, {
                    onClick: back,
                    "style-type": "success",
                    text: "Spara"
                  }),
                  _createVNode(RegularButton, {
                    onClick: back,
                    text: "Tillbaka"
                  })
                ])
              ], 32)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mb-4" }, "Dina förändringar sparas automatiskt.", -1)),
              _createElementVNode("form", {
                action: "",
                class: "grid grid-cols-2 text-sm font-regular gap-4",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1" }, " Label ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                    placeholder: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.label) = $event))
                  }, null, 512), [
                    [_vModelText, item.value.label]
                  ])
                ]),
                (item.value.key !== 'form_file')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1" }, " Placeholder ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.placeholder) = $event))
                      }, null, 512), [
                        [_vModelText, item.value.placeholder]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.value.key === 'form_file')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fileUploadIsRequired).value = $event))
                        }, null, 512), [
                          [_vModelCheckbox, fileUploadIsRequired.value]
                        ]),
                        _cache[16] || (_cache[16] = _createTextVNode(" Obligatorisk ", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.value.key === 'form_ssn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ssnOnlyAllowedYears).value = $event))
                        }, null, 512), [
                          [_vModelCheckbox, ssnOnlyAllowedYears.value]
                        ]),
                        _cache[17] || (_cache[17] = _createTextVNode(" Godkänn endast personer som är födda specifika år ", -1))
                      ]),
                      (ssnOnlyAllowedYears.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("button", {
                              onClick: addYear,
                              class: "text-blue-2 hover:text-blue-1 text-left"
                            }, " Lägg till år "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ssnAllowedYears.value, (year, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "flex items-center gap-2",
                                key: i
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "appearance-none border-gray-2 block w-28 bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                                  placeholder: "Ange år",
                                  "onUpdate:modelValue": ($event: any) => ((ssnAllowedYears.value[i]) = $event)
                                }, null, 8, _hoisted_14), [
                                  [_vModelText, ssnAllowedYears.value[i]]
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (removeYear(i)),
                                  class: "bg-gradient-to-t from-red-700 to-red-2 hover:from-red-600 hover:to-red-3 text-sm rounded-md text-white px-3 py-3"
                                }, [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                ]))], 8, _hoisted_15)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.value.key === 'form_ssn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ssnAgeBeforeAndAfterPeriod.value.value) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, ssnAgeBeforeAndAfterPeriod.value.value]
                        ]),
                        _cache[19] || (_cache[19] = _createTextVNode(" Godkänn endast personer som har viss ålder under viss period ", -1))
                      ]),
                      (ssnAgeBeforeAndAfterPeriod.value.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("button", {
                              onClick: addPeriod,
                              class: "text-blue-2 hover:text-blue-1 text-left"
                            }, " Lägg till period "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ssnAgeBeforeAndAfterPeriod.value.periods, (period, i) => {
                              return (_openBlock(), _createBlock(SsnAgeInPeriods, {
                                period: period,
                                key: period.key,
                                index: i,
                                onRemovePeriod: ($event: any) => (removePeriod(i)),
                                onSavePeriod: savePeriod,
                                class: "flex flex-col gap-2 p-4 text-darkGray-1 bg-white ring-1 ring-orange-2 w-full rounded-md max-w-[500px]"
                              }, null, 8, ["period", "index", "onRemovePeriod"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(RegularButton, {
                    onClick: remove,
                    "style-type": "cancel",
                    text: "Ta bort fält"
                  }),
                  _createVNode(RegularButton, {
                    onClick: back,
                    "style-type": "success",
                    text: "Spara"
                  }),
                  _createVNode(RegularButton, {
                    onClick: back,
                    text: "Tillbaka"
                  })
                ])
              ], 32)
            ]))
}
}

})